import { selectPlaceData, selectPlaceFilters } from 'containers/MapDetails/placeSlice'
import { getListRows, groupKey, ListRow, PlaceWarehouses } from './utils'
import usePlaceMapParams from './hooks/usePlaceMapParams'
import useTranslation from 'hooks/useTranslation'
import React, { useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { useReduxSelector } from 'store'
import ListItem from './ListItem'

interface ListProps {
  header: React.JSX.Element
  isGroupMode: boolean
  selectedKey?: string
  selectGroup: (key: string) => void
}

const List: React.FC<ListProps> = ({ header, isGroupMode, selectedKey, selectGroup }) => {
  const filters = useReduxSelector(selectPlaceFilters)
  const place = useReduxSelector(selectPlaceData)
  const { placeId, id } = usePlaceMapParams()
  const { push, replace } = useHistory()
  const { t } = useTranslation('placeMap')

  const rows = useMemo(() => getListRows(
    place?.warehouses as PlaceWarehouses | undefined,
    filters,
    !isGroupMode
  ), [place?.warehouses, filters, isGroupMode])

  const select = (row: ListRow) => {
    if (isGroupMode) {
      selectGroup(groupKey(row.warehouseTypeId, row.hash))
    } else if (row.id) {
      const action = id ? replace : push
      action(`/placemap/${placeId}/${row.id}`)
    }
  }

  return (
    <div className='placeMap__list__wrapper'>
      {header}
      <div className='placeMap__list'>
        {rows.length > 0
          ? rows.map(row => <ListItem
            key={row.key}
            row={row}
            isSelected={row.key === selectedKey}
            select={select}
          />)
          : <p className='placeMap__list__empty'>{t('noResults')}</p>}
      </div>
    </div>
  )
}

export default List
